(function () {
  'use strict';

  var TOAST_ID = 'parently-cart-added-toast';
  var PENDING_KEY = 'parently-cart-added-toast-pending';
  var visibleTimer;
  var pendingClearTimer;

  function getToast() {
    return document.getElementById(TOAST_ID);
  }

  function itemMessage(quantity) {
    var count = Number(quantity);
    if (!Number.isFinite(count) || count < 1) count = 1;
    return count === 1 ? 'Item added' : count + ' items added';
  }

  function hideToast() {
    var toast = getToast();
    if (!toast) return;

    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
  }

  function showToast(quantity) {
    var toast = getToast();
    if (!toast) return;

    var message = toast.querySelector('[data-cart-toast-message]');
    if (message) message.textContent = itemMessage(quantity);

    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    clearTimeout(visibleTimer);
    visibleTimer = setTimeout(function () {
      hideToast();
    }, 4500);
  }

  function savePending(quantity) {
    try {
      var pending = {
        quantity: quantity || 1,
        createdAt: Date.now()
      };
      sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
      clearTimeout(pendingClearTimer);
      pendingClearTimer = setTimeout(function () {
        sessionStorage.removeItem(PENDING_KEY);
      }, 10000);
    } catch (error) {
      // Storage can be unavailable in private browsing; the current-page toast still works.
    }
  }

  function showPending() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      if (!raw) return;

      var pending = JSON.parse(raw);
      sessionStorage.removeItem(PENDING_KEY);
      if (!pending || Date.now() - Number(pending.createdAt) > 15000) return;
      showToast(pending.quantity);
    } catch (error) {
      try {
        sessionStorage.removeItem(PENDING_KEY);
      } catch (storageError) {
        // Ignore storage cleanup failures.
      }
    }
  }

  function installCartAddedListener() {
    window.addEventListener('parently:cart-added', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var quantity = Number(detail.quantity) || 1;
      savePending(quantity);
      showToast(quantity);
    });
  }

  function installCloseButton() {
    var toast = getToast();
    if (!toast) return;

    var close = toast.querySelector('[data-cart-toast-close]');
      if (close) {
        close.addEventListener('click', function () {
          clearTimeout(visibleTimer);
          hideToast();
        });
      }
  }

  installCartAddedListener();
  installCloseButton();
  showPending();
})();
